import {useUser} from '@product-web/user'

import {usePleoGuideMilestones} from './pleo-guide/use-pleo-guide-milestones'

export const usePleoGuideStatus = () => {
    const user = useUser()
    const isOwner = user?.role === 'owner'
    const {data: milestones} = usePleoGuideMilestones()
    const hasCompletedPleoGuideSteps = Boolean(
        milestones && Object.values(milestones).filter((milestone) => !milestone).length === 0,
    )

    const awaitingPleoGuideStatus = isOwner ? !milestones : false

    const hasFinishedPleoGuide = isOwner
        ? hasCompletedPleoGuideSteps && !!user.status?.onboarded
        : true

    return {
        awaitingPleoGuideStatus,
        hasFinishedPleoGuide,
    }
}
